import { FC } from 'react';
import styled from 'styled-components';
import { grid } from 'styled-system';

import { Box } from '../Box';
import { GridProps } from './props';

export const Grid: FC<GridProps> = ({ as, ...rest }) => (
  <StyledGrid forwardedAs={as} {...rest} />
);

Grid.defaultProps = {
  as: 'div',
};

const StyledGrid = styled(Box)<GridProps>`
  display: grid;
  ${grid};
`;
